import GroupCardListItem from './GroupCardListItem';

export default GroupCardListItem;
